<template>
    <div>
        <b-container fluid class="px-5">
            <div class="mt-4 d-flex align-items-start justify-content-between">
                <div>
                    <h1 class="page-title">Familles</h1>
                    <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
                </div>
            </div>

            <b-card class="mt-2 mb-4 shadow-sm">

                <b122-table
                        identifier="B122TableFamily"
                        init-b122-table-url="/family/initB122Table"
                        get-b122-table-results-url="/family/getB122TableResults"
                        :fields="tableFields"
                        @setTotalCount="setTotalCount"
                >

                <template #cell(speciesCount)="row">
                    {{row.data}}
                </template>

                </b122-table>

            </b-card>
        </b-container>
    </div>
</template>

<script>

    import B122Table from "../../components/b122/B122Table";

    export default {

        name: 'FamilyIndex',

        components: {
            B122Table
        },

        data() {
            return {

                totalCount: 0,

                tableFields: [
                  {
                    label: "Name",
                    key: "name",
                    sortable: true
                  },
                  {
                    label: "Nombre d'espèces",
                    key: "speciessCount",
                    sortKey: "size(d.speciess)",
                    sortable: true
                  }
                ]
            }
        },

        methods: {
            setTotalCount(totalCount) {
                this.totalCount = totalCount
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/family/FamilyIndex.vue